(function ($, Cobalt, undefined) {
    Cobalt.CMS = {
        dependentScripts: function () {
            return [
                { dependency: Cobalt.TinyMCE, name: "Cobalt.TinyMCE" }
            ];
        },
        formType: null,
        CobaltCss: [],
        ProjectCss: [],
        getTinyMCECss: function () {
            var cobaltCss = Cobalt.CMS.CobaltCss.concat(Cobalt.CMS.ProjectCss).join(',');
            return cobaltCss;
        },
        initialized: false,
        priority: 0,
        initialize: function () {
            Cobalt.CMS.initialized = true;

            var $form = null;
            if ($("#post-form").length > 0) {
                Cobalt.CMS.formType = "post";
                $form = $("#post-form");
                Cobalt.CMS.initializeRevisionSystem();
            }
            else if ($("#page-form").length > 0) {
                Cobalt.CMS.formType = "page";
                $form = $("#page-form").parents("form");
            }

            if ($form == null) {
                return;
            }

            Cobalt.TinyMCE.optionsOverridden = true;
            Cobalt.TinyMCE.options = {
                skin_url: Cobalt.TinyMCE.skin_url,
                setup: function (ed) {
                    ed.on("init", function (evt) {
                        var editor = evt.target;

                        Cobalt.TinyMCE._enableBlockQuoteBreakout(editor);

                        $("#" + editor.id + "_blockquote").on("click", function () {
                            editor.dom.add(editor.getBody(), 'p', null, '<br />');
                        });

                        Cobalt.TinyMCE.tinyMCELoaded(editor);
                    });
                },
                end_container_on_empty_block: true,
                body_class: "text u-typography-format content-container cms-editor",
                content_css: Cobalt.CMS.getTinyMCECss(),
                formats: {
                    bold: { inline: 'strong' },
                    italic: { inline: 'em' },
                    strikethrough: { inline: 'del' },
                    address: { inline: 'addr' },
                    removeformat: [
                    {
                        selector: 'b,strong,em,i,font,u,strike,sub,sup,dfn,code,samp,kbd,var,cite,mark,q,del',
                        remove: 'all',
                        split: true,
                        expand: false,
                        block_expand: true,
                        deep: true
                    },
                    { selector: 'span', attributes: ['style', 'class'], remove: 'empty', split: true, expand: false, deep: true },
                    { selector: '*', attributes: ['style', 'class'], split: false, expand: false, deep: true }
                    ]
                },
                selector: "#field-body-wysiwyg",
                menubar: false,
                width: "100%",
                height: "400px",
                plugins: "colorpicker,fullscreen,hr,image,link,lists,media,noneditable,paste,searchreplace,tabfocus,table,textcolor",
                tabfocus_elements: "field-custom-css",
                external_plugins: Cobalt.TinyMCE._addExtraCustomPlugins("imageborder,postexcerpt,postpagebreak,postwidget,spoiler,tabgroupaddtab,videoembed,xenonmedia,incontentad"),
                dialog_type: "modal",
                toolbar: "paste bold italic underline strikethrough blockquote | formatselect alignleft aligncenter alignright | fontselect fontsizeselect forecolor | searchreplace | fullscreen"
                    + " | bullist numlist | hr removeformat | outdent indent spoiler | link unlink | image | imageborder | xenonmedia | tabgroupaddtab | videoembed | postpagebreak | postwidget | postexcerpt | table | incontentad",
                extended_valid_elements: "article[id|class],header,aside[class],div[*],tab[*],iframe[*]",
                custom_elements: 'tab',
                block_formats: "Paragraph=p;Header 2=h2;Header 3=h3;Header 4=h4;Header 5=h5;Header 6=h6;Pre=pre;",
                relative_urls: false,
                paste_auto_cleanup_on_paste: true,
                paste_remove_styles: true,
                paste_remove_styles_if_webkit: true,
                paste_strip_class_attributes: "all",
                gecko_spellcheck: true,
                paste_text_sticky: true,
                forced_root_block: "p",
                heading_clear_tag: "p",
                schema: "html5",
                remove_script_host: false,
                media_live_embeds: false
            };

            if ($("div#page-form").html() != undefined || $("div#post-form").html() != undefined) {
                Cobalt.CMS.setupPageForm();
            }

            $(".module.cms.page-form .user-action-save-changes").click(function () {
                $("#page-form #field-save-changes").click();
            });

            $(".module.cms.post-form .user-action-save-changes").click(function () {
                $("#post-form #field-save-changes").click();
            });

            $(".module.cms.post-form #field-preview").click(function (e) {
                e.preventDefault();
                var $postForm = $("form#post-form");
                var postID = $(this).attr("data-post-id");
                if (postID > 0) {
                    $postForm.attr("action", "/cp/cms/posts/" + postID + "/preview");
                } else {
                    $postForm.attr("action", "/cp/cms/posts/preview");
                }
                $postForm.attr("target", "preview");
                $postForm.submit();
                $postForm.attr("action", "");
                $postForm.attr("target", "");
            });

            $(".post-tab-item-link,.b-pagination-next a,.b-pagination-prev a").click(function (e) {
                e.preventDefault();
                var postID = $(this).attr("data-post-id");
                var categoryID = $(this).attr("data-category-id");
                var pageNumber = $(this).attr("data-page-number");
                var $postForm = $("form#post-form");
                var isUserContent = $(".user-content").length > 0;

                if (postID > 0) {
                    if (isUserContent) {
                        $postForm.attr("action", "/my-content/" + categoryID + "/posts/" + postID + "/preview/page-" + pageNumber);
                    }
                    else {
                        $postForm.attr("action", "/cp/cms/posts/" + postID + "/preview/page-" + pageNumber);
                    }
                } else {
                    if (isUserContent) {
                        $postForm.attr("action", "/my-content/" + categoryID + "/posts/preview/page-" + pageNumber);
                    }
                    else {
                        $postForm.attr("action", "/cp/cms/posts/preview/page-" + pageNumber);
                    }
                }
                $postForm.attr("target", "preview");
                $postForm.submit();
                $postForm.attr("action", "");
                $postForm.attr("target", "");
            });


            $.fn.extend({
                disableSelection: function () {
                    this.each(function () {
                        this.onselectstart = function () { return false; };
                        this.unselectable = "on";
                        jQuery(this).css('-moz-user-select', 'none');
                    });
                }
            });

            // Prevent nav that could cause the user to lose data
            var warningMessage = "You appear to have unsaved changes. Any unsaved changes will be lost if you leave this page.";

            $form.data("_submitClicked", false);
            var checkChanges = function (e) {

                if ($form.data("_submitClicked")) {
                    return null;
                }

                $form.data("_submitClicked", false);

                var showWarning = false;

                $('input[type=text]').each(function () {
                    if (this.value != this.defaultValue) {
                        showWarning = true;
                    }
                });
                $('input[type=checkbox]').each(function () {
                    if (this.checked != this.defaultChecked) {
                        showWarning = true;
                    }
                });
                $('textarea:not(.j-wysiwyg-editor)').each(function () {
                    if (this.value != this.defaultValue) {
                        showWarning = true;
                    }
                });
                $('select').each(function () {
                    if ($(this).is(":visible") && this.options.selectedIndex != -1 && !this.options[this.selectedIndex].defaultSelected) {
                        showWarning = true;
                    }
                });

                $form.find('textarea').each(function () {
                    var editor = Cobalt.TinyMCE.getEditorFromForm($form);
                    //var mceInstance = $(this).tinymce();
                    if (editor && editor.isDirty()) {
                        showWarning = true;
                    }
                });

                if (showWarning) {
                    return warningMessage;
                } else {
                    return null;
                }
            };

            $(window).on("beforeunload", checkChanges);

            $('button[type=submit]').on('click', function () {
                $form.data("_submitClicked", true);
            });

            $(".col-right .sub-caption > span").on("click", function (e) {
                var anchor = $(this).parent().find(".cms-toggle-section");
                if (anchor.length > 0) {
                    anchor.click();
                }
            });

            // Default Post Template
            var defaultPostFunc = function () {
                var postForm = $("div#post-form,div.post-form");
                if (postForm.length > 0 && postForm.attr('data-template-id')) {
                    if (typeof tinyMCE === 'undefined' || tinyMCE.activeEditor == null) {
                        setTimeout(defaultPostFunc, 200);
                        return;
                    } else {
                        var isFromTemplate = postForm.data('post-type') === 3;
                        var isSavedToDatabase = postForm.data('saved') === "True";
                        if (!isFromTemplate && !isSavedToDatabase) {
                            var defaultTemplatePostID = postForm.data('template-id');
                            if (defaultTemplatePostID) {
                                Cobalt.CMS.copyTemplate(defaultTemplatePostID);
                            }
                        }
                    }
                }
            };
            defaultPostFunc();

            Cobalt.CMS.initializeRedirectUrlField();
        },
        initializeRedirectUrlField: function () {
            var setRedirectUrlField = $("#field-set-redirect-url");
            if (setRedirectUrlField.length > 0) {
                var redirectField = $("#form-field-redirect-url");

                if (setRedirectUrlField.is(":checked")) {
                    redirectField.removeClass("hide").show();
                }

                setRedirectUrlField.click(function() {
                    if (setRedirectUrlField.is(":checked")) {
                        redirectField.removeClass("hide").show();
                    } else {
                        redirectField.hide();
                    }
                });
            }
        },
        calculatePageUrl: function () {
            var newSlug = $("#field-slug").val();
            if (newSlug.length == 0) {
                newSlug = $("#field-title").val();
                if (newSlug == $("#field-title").attr("placeholder")) {
                    newSlug = $("#field-display-slug").text();
                }
            }
            if (newSlug.length > 1) {
                var url = Cobalt.Routes.Instance.CPPageGetUrl($("#field-category").val(), { title: newSlug });
                $.ajax({
                    url: url,
                    success: function (results) {
                        var url = results.Url;
                        var slug = results.Slug;
                        $("#field-display-url").html("<a href=\"" + url + "\" target=\"blank\">" + url + "</a>");
                        $("#field-display-slug").text(slug);
                    }
                });
            }
        },
        calculatePostUrl: function () {
            var newSlug = $("#field-title").val();
            if (newSlug == $("#field-title").attr("placeholder")) {
                newSlug = "";
            }

            if (newSlug == "") {
                newSlug = "your-title";
            }

            if (newSlug.length > 1) {

                var categoryID = $("#field-parent-category").val();
                if (categoryID == "") {
                    return;
                }
                var url = Cobalt.Routes.Instance.CPPostGetUrl(categoryID, { title: newSlug, pageID: $("#field-parent-page").val(), postID: $("#field-post").val() });
                $.ajax({
                    url: url,
                    success: function (results) {
                        var url = results.Url;
                        if (url != null) {
                            $("#field-display-url").html("<a href=\"" + url + "\" target=\"blank\">" + url + "</a>");
                        }
                        else {
                            $("#field-display-url").html("Choose a valid folder");
                        }
                    }
                });
            }

        },
        setupPageForm: function () {

            $("#field-title").focusout(function () {
                if (Cobalt.CMS.formType == "page") {
                    Cobalt.CMS.calculatePageUrl();
                } else {
                    Cobalt.CMS.calculatePostUrl();
                }
            });

            $("#field-category").change(function () {
                Cobalt.CMS.calculatePageUrl();
            });

            $("#field-parent-page").change(function () {
                Cobalt.CMS.calculatePostUrl();
            });

            $("#field-parent-category").change(function () {
                Cobalt.CMS.calculatePostUrl();
            });

            $("#field-slug").tAutoSizer({
                maxWidth: 400,
                stepSize: 10
            });

            $(".field-url-wrapper > a.accept").click(function () {
                if ($("#field-slug").hasClass("hidden")) {
                    $("#field-display-slug").hide();
                    if ($("#field-slug").val().length == 0) {
                        $("#field-slug").val($("#field-display-slug").text());
                    }
                    $("#field-slug").removeClass("hidden");
                    $("#field-slug").keyup();
                    $(this).text("Ok");
                    $(".field-url-wrapper > a.cancel").removeClass("hidden");
                }
                else {
                    $(".field-url-wrapper > a.cancel").addClass("hidden");
                    $("#field-display-slug").show();
                    $("#field-slug").addClass("hidden");
                    $(this).text("Edit");
                    Cobalt.CMS.calculatePageUrl();
                }
            });

            $(".field-url-wrapper > a.cancel").click(function () {

                $(this).addClass("hidden");
                $("#field-slug").addClass("hidden");
                $("#field-slug").val("");
                $("#field-display-slug").show();
                $(".field-url-wrapper > a.accept").text("Edit");

            });

            // Form type specific fieds
            var pageTypeField = $(":radio[name='type']");
            if (pageTypeField.length > 0) {
                pageTypeField.change(Cobalt.CMS.toggleTypeFields);
                Cobalt.CMS.toggleTypeFields();
            }

            // Page form publish date.


            var isScheduled = $("#field-is-scheduled");
            if (isScheduled.length > 0) {

                var label = $("#form-field-publish-date").find("label");

                var setDateText = L.Global.ContentManagement.PageFormSetDate();

                var setDateLink = $("<a>").attr("href", "#").html(setDateText).click(function () {
                    if ($(this).html() == setDateText) {
                        Cobalt.CMS.togglePublishDate($(this), true);
                    }
                    else {
                        Cobalt.CMS.togglePublishDate($(this), false);
                    }
                    return false;
                });

                label.append(setDateLink);
                Cobalt.CMS.togglePublishDate(setDateLink, (isScheduled.val() == "y"));
            }

            $("#field-title").trigger("focusout");

            var postForm = $("div#post-form");
            if (postForm.length > 0 && postForm.attr("data-post-type") !== undefined) {
                setTimeout(function () {
                    Cobalt.ImageManager.setPostType(postForm.attr("data-post-type"));
                    Cobalt.ImageManager.showModal(document, Cobalt.CMS.copyTemplate, "template-select", $("#field-parent-category").val());
                }, 500);
            }
        },
        togglePublishDate: function (link, on) {

            var setDateText = L.Global.ContentManagement.PageFormSetDate();
            var publishDate = $("#field-publish-date-date");
            var publishTime = $("#field-publish-date-time");
            var timezone = $("#form-field-publish-date span.timezone");
            var pageFormPublishWhenDiv = $("#form-field-publish-date");
            var label = pageFormPublishWhenDiv.find("label");
            var isScheduled = $("#field-is-scheduled");
            if (on) {
                link.html(L.Global.ContentManagement.PageFormDoNotSetDate());
                isScheduled.val("y");
                label.find("span").html("Publish as Scheduled");
                $('div#post-form .j-publish-submit').text('Publish as Scheduled');
                publishDate.show();
                publishTime.show();
                timezone.show();
            }
            else {
                isScheduled.val("n");
                label.find("span").html("Publish Immediately");
                $('div#post-form .j-publish-submit').text('Publish');
                link.html(setDateText);
                publishDate.hide();
                publishTime.hide();
                timezone.hide();
            }
        },
        copyTemplate: function (postID) {
            $.getJSON(Cobalt.Routes.Instance.CategoryPostGetData(postID), function (data) {
                var bodyDiv = $("#form-field-body");
                bodyDiv.find("ul.tabbed-tabs li").first().click();
                tinyMCE.activeEditor.setContent(data.Body);

                // Exerpt
                $("#field-exerpt").val(data.Exerpt);

                // Tags
                $(data.Tags).each(function (i, val) {
                    $("#field-tags")[0].appendTag(val);
                });

                // Status
                $("#field-status").val(data.Status);

                // Post Image
                $("#field-post-image-id").val(data.PostImageID);
                if (data.PostImageUrl !== "") {
                    $("#field-post-image").parent().append($("<img>").attr("src", data.PostImageUrl));
                }

                // Is Pinned
                if (data.Pinned === true) {
                    $("#field-is-pinned").attr("checked", "checked");
                }

                // Allow Comments
                $("#field-allow-comments").val(data.AllowComments);

                // Allow Ratings
                $("#field-allow-ratings").val(data.AllowRatings);

                // Post Security
                if (data.Security === true) {
                    $("#field-body-disable-security").attr("checked", "checked");
                }
            });
        },
        toggleTypeFields: function () {
            var pageType = $(":radio[name='type']:checked").val();
            pageType = parseInt(pageType, null);
            var staticTypeFields = $("#static-type-fields");
            var collectionTypeFields = $("#collection-options");
            var tagCollectionTypeFields = $("#tag-collection-options");

            var allowComments = $("#form-field-allow-comments");
            var allowRatings = $("#form-field-allow-ratings");

            switch (pageType) {

                case 1: // Static
                    staticTypeFields.show();
                    allowRatings.show();
                    allowComments.show();
                    collectionTypeFields.hide();
                    tagCollectionTypeFields.hide();
                    break;
                case 2: // Post Collection
                    staticTypeFields.hide();
                    allowRatings.hide();
                    allowComments.hide();
                    collectionTypeFields.show();
                    tagCollectionTypeFields.hide();
                    break;
                case 4: // Tag Collection
                    staticTypeFields.hide();
                    allowRatings.hide();
                    allowComments.hide();
                    collectionTypeFields.show();
                    tagCollectionTypeFields.show();
                    break;
            }
        },
        initializeRevisionSystem: function () {
            var postID = $("#field-post").val();
            $("ul.revisions>li>a").each(function () {
                $(this).click(function () {
                    var revisionNumber = $(this).attr("data-revision");

                    if (confirm("Are you sure you want to restore the content of this post to an earlier revision (Revision " + revisionNumber + ")?")) {
                        // Get the selected tab (wysiwyg or editor)
                        var markupMode = $("div#form-field-body ul.tabbed-tabs > li.selected").attr("data-markup-mode");

                        var revisionContent = $.ajax(
                        {
                            type: "POST",
                            url: "/ajax/posts/" + postID + "/restore-revision?revisionNumber=" + revisionNumber,
                            dataType: "json",
                            success: function (result) {
                                $("#field-body-wysiwyg").val(result.Body);
                                // Explicity specifying the editor name so that the revision is restored to the correct editor.
                                tinymce.editors['field-body-wysiwyg'].setContent(result.Body);
                                $("#field-body").val(result.Body);
                            }
                        });
                    }
                });
            });
        }
    };


})(jQuery, Cobalt);


// WEBPACK FOOTER //
// ./content/js/Cobalt/Cobalt.CMS.js